import { gql } from "@apollo/client";

const GET_INTEGRATION_QUERY = gql`
  query get_integration($id: String!) {
    integration(id: $id) {
      id
      integration_type
      public_authorization
      configuration
      status
      filters {
        id
        production
        backfills
        proofs
        lateUploads
        configuration
        status
      }
      assistance
    }
  }
`;

const GET_INTEGRATION_CHANNEL_QUERY = gql`
  query get_integration_channel($id: String!, $channelId: String!) {
    integration(id: $id) {
      id
      channel_by_id(channel_id: $channelId)
    }
  }
`;

const LIST_INTEGRATIONS_QUERY = gql`
  query list_integrations {
    integrations {
      edges {
        node {
          id
          integration_type
          public_authorization
          status
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

const START_OAUTH_QUERY = gql`
  query start_oauth($entity: String!, $oauthType: String!, $id: String, $name: String) {
    start_oauth(entity: $entity, oauthType: $oauthType, id: $id, name: $name)
  }
`;

const START_KEY_OAUTH_QUERY = gql`
  query start_key_oauth($entity: String!, $oauthType: String!, $id: String, $name: String!) {
    start_oauth(entity: $entity, oauthType: $oauthType, id: $id, name: $name)
    validateCredentialUniqueName(name: $name) {
      ... on ValidateCredentialOk {
        ok
      }
      ... on ValidationErrors {
        errors {
          typeId
          properties
        }
      }
    }
  }
`;

export {
  GET_INTEGRATION_CHANNEL_QUERY,
  GET_INTEGRATION_QUERY,
  LIST_INTEGRATIONS_QUERY,
  START_KEY_OAUTH_QUERY,
  START_OAUTH_QUERY,
};
